import { useState } from 'react';
import { Container } from './CalculationTraceStyles';
import { PerformanceReturnDetails } from 'components/PerformanceReturnDetails/PerformanceReturnDetails';
import { PerformanceReturns } from 'components/PerformanceReturns/PerformanceReturns';
import { Stream } from 'types/PerformanceReturns';

type Props = {
  benchmarkId?: string;
};

type Details = {
  asOfDate: string;
  stream?: Stream | null;
  streamCompare?: Stream | null;
};

export function CalculationTrace({ benchmarkId }: Props) {
  const [showDetails, setShowDetails] = useState(false);
  const [details, setDetails] = useState<Details>();

  function onDrillDown(
    date: string,
    stream?: Stream | null,
    streamCompare?: Stream | null
  ) {
    setDetails({ asOfDate: date, stream, streamCompare });
    setShowDetails(true);
  }

  return (
    <Container>
      <div style={{ display: showDetails ? 'none' : 'block' }}>
        <PerformanceReturns
          benchmarkId={benchmarkId}
          onDrillDown={onDrillDown}
        />
      </div>

      {showDetails ? (
        <PerformanceReturnDetails
          stream={details?.stream}
          asOfDate={details?.asOfDate}
          streamCompare={details?.streamCompare}
          onBack={() => setShowDetails(false)}
        />
      ) : null}
    </Container>
  );
}
